/* Vurve campaign navigation: URL-only, no storage, no pixel events or cookie copying. */
(function () {
  'use strict';
  var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'utm_source_platform', 'utm_creative_format', 'utm_marketing_tactic', 'fbclid', 'gclid', 'dclid', 'gbraid', 'wbraid', 'msclkid', 'ttclid'];
  var hosts = ['www.vurve.online', 'vurve.online', 'vurve.vhx.tv'];
  var originals = new WeakMap();
  function permitted() {
    try {
      var p = window.Shopify && window.Shopify.customerPrivacy;
      return navigator.globalPrivacyControl !== true && !!p && p.marketingAllowed() === true && p.analyticsProcessingAllowed() === true && p.saleOfDataAllowed() === true;
    } catch (_) { return false; }
  }
  function update(a) {
    if (!a || !a.getAttribute('href') || a.hasAttribute('download')) return;
    var current = a.getAttribute('href');
    var previous = originals.get(a);
    var raw = previous && previous.output === current ? previous.input : current;
    if (/^(#|mailto:|tel:|javascript:)/i.test(raw)) return;
    var url;
    try { url = new URL(raw, window.location.href); } catch (_) { return; }
    if (url.protocol !== 'https:' || url.username || url.password) return;
    var studio = hosts.indexOf(url.hostname) !== -1;
    var internal = url.origin === window.location.origin && (url.pathname === '/' || /^\/(pages|blogs|products|collections)(\/|$)/.test(url.pathname)) && !/^\/pages\/(director-dashboard|contact)(\/|$)/.test(url.pathname);
    if (!studio && !internal) return;
    // Vimeo's own checkout accepts monthly=1 and plan=yearly. Leave any explicit selection untouched.
    if (studio && /^\/checkout\/subscribe\/purchase\/?$/.test(url.pathname) && !['plan', 'monthly', 'yearly', 'frequency'].some(function (key) { return url.searchParams.has(key); })) {
      var label = (a.textContent || '') + ' ' + (a.getAttribute('aria-label') || '');
      if (/\b(annual|yearly)\b/i.test(label)) url.searchParams.set('plan', 'yearly');
      else url.searchParams.set('monthly', '1');
    }
    if (permitted()) {
      var source = new URLSearchParams(window.location.search);
      keys.forEach(function (key) {
        var value = source.get(key);
        if (value && value.length <= 512 && !/[\u0000-\u001f\u007f]/.test(value) && !url.searchParams.has(key)) url.searchParams.set(key, value);
      });
    }
    var output = url.href;
    originals.set(a, {input: raw, output: output});
    if (current !== output) a.setAttribute('href', output);
  }
  function refresh() { document.querySelectorAll('a[href]').forEach(update); }
  ['click', 'auxclick', 'pointerdown', 'contextmenu', 'focusin'].forEach(function (name) {
    document.addEventListener(name, function (event) { update(event.target.closest && event.target.closest('a[href]')); }, true);
  });
  document.addEventListener('visitorConsentCollected', refresh);
  document.addEventListener('DOMContentLoaded', refresh);
  window.addEventListener('load', refresh);
  if (window.Shopify && window.Shopify.loadFeatures && !window.Shopify.customerPrivacy) {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) { if (!error) refresh(); });
  }
  refresh();
}());
